;ailtire.ajax = function() {
    var

    //flag indicating page is unloading, ajax errors are suppressed if true
    mUnloading = false,

    //error message displayed when an ajax error occurs.
    mErrorMsg = "An error has occurred",

    //
    //init
    //
    init = function() {
        //Setup default for ajax errors
        $.ajaxSetup({
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                if (!mUnloading) {
                    alert(mErrorMsg + ": " + errorThrown);
                }
            }
        });

        //set the unloading flag when leaving the page.
        $(window).bind("beforeunload", function() {
            mUnloading = true;
        });

    },


    //
    //post to an mvc controller
    //
    post = function (url, data, callback) {
        //This one works with complex json objects
        $.ajax({
            type: 'post',
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (result) {
                if (!checkTimeout(result)) {
                    if (callback) {
                        callback(result);
                    }
                }
            }
        });
    },

    //
    //synchronous post to MVC controller
    //
    postSync = function (url, data) {
        //$.post(
        //    url,
        //    data
        //);

        var ret = null;

        //This one works with complex json objects
        $.ajax({
            type: 'post',
            async: false,
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (result) {
                //if (!checkTimeout(result)) {
                    ret = result;
                //}
            }
        });

        return ret;
    },

    //
    // Post FormData structure
    //
    postFormData = function (url, data, callback) {
        //post it
        $.ajax({
            type: 'POST',
            url: url,
            contentType: false,
            processData: false,
            data: data,
            success: function(result) {
                if (callback) {
                    callback(result);
                }
            }
        });

    },


    //
    //get from a controller url
    //
    get = function (url, callback) {
        //This one works with complex json objects
        $.get(
            url,
            function (result) {
                if (!checkTimeout(result)) {
                    if (callback) {
                        callback(result);
                    }
                }
            }
        );
    },

    //
    //see if timeout was returned by ajax, returns the timeout url if session has timed out
    //
    checkTimeout = function(result) {
        if (result && typeof(result) == "object" && result.TimeoutUrl) {
            window.location = result.TimeoutUrl;
            return true;
        } else {
            return false;
        }
    };

    //call init
    $(document).ready(init);

    return {
        post: post,
        postSync: postSync,
        postFormData: postFormData,
        get: get
    };
}();